export const findIndexFunc = (arr: any[], item: any, key: string) =>
    arr.findIndex((obj) => {
        const searchingElem = arr.find((elem) => elem[key] === item);

        return obj === searchingElem;
    });
